// extracted by mini-css-extract-plugin
export default {"orContainer":"HwKSHSBS","hrContainer":"_1smwqC9Y","orDiv":"_27EYRR6t"};